import { PartyType } from '@parties/src/types';
import { useQuery } from 'react-query';
import { wgApi } from '../../../../app/src/features/api/wgApi';
import { GetSupportedYellowhiveflowInsurancesResponse } from 'wg-api-sdk';

const getUseYellowhiveFlowsInsurances = (partyType: PartyType) => [
  'flow-config',
  'yellowhive',
  'insurances',
  partyType,
];

const getSupportedYellowhiveflowInsurances = async (
  partyType: PartyType,
): Promise<GetSupportedYellowhiveflowInsurancesResponse> => {
  const { data, isError } =
    await wgApi.get<GetSupportedYellowhiveflowInsurancesResponse>(
      `/v1/api/yellowhiveflows/supported-insurances`,
      {
        query: { party_type: partyType },
      },
    );
  if (isError) throw new Error();
  return data;
};

export const useYellowhiveFlowsInsurances = (partyType: PartyType) => {
  return useQuery(
    getUseYellowhiveFlowsInsurances(partyType),
    () => getSupportedYellowhiveflowInsurances(partyType),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    },
  );
};
